import React, { Component, PropTypes } from 'react';
import SearchWidget from './searchWidget-partnerFinder';
import {
  accomCompanyTypesFields,
  nonAccomCompanyTypesFields,
  contractorCompanyTypesFields,
  basicBuyerTypes,
  DMOtypes,
  otherBuyersTypes,
} from '../../utils/select-fields';

class leftNav extends Component {
    constructor(props) {
      super(props);
      this.state = {
        filters: {
          Supplier: [
            {
              filterName: 'Product Types',
              filterList: ['Accommodation', 'Non-Accommodation'],
            },
            {
              hide: true,
              filterName: 'Property Types',
              filterList: accomCompanyTypesFields,
            },
            {
              hide: true,
              filterName: 'Business Types',
              filterList: nonAccomCompanyTypesFields,
            },
            {
              filterName: 'Segments',
              filterList: ['Adventure', 'Business', 'Cultural and Heritage', 'Eco-Tourism', 'Family', 'Group Travel', 'Health and Wellness', 'Luxury', 'Senior Travel', 'Sport Tourism', 'Student Travel'],
            },
          ],
          Contractor: [
            {
              filterName: 'Business Types',
              filterList: basicBuyerTypes,
            },
            {
              filterName: 'Segments',
              filterList: ['Adventure', 'Business', 'Cultural and Heritage', 'Eco-Tourism', 'Family', 'Group Travel', 'Health and Wellness', 'Luxury', 'Senior Travel', 'Sport Tourism', 'Student Travel'],
            },
          ],
          DMOs: [
            {
              filterName: 'Business Types',
              filterList: DMOtypes,
            },
          ],
          Other: [
            {
              filterName: 'Business Types',
              filterList: otherBuyersTypes,
            },
          ],
        },
      };
    }


    render() {
      return (
        <div className={this.props.className} style={{ overflowX: 'visible', overflowY: 'scroll' }}>
          <div className="integration-left-nav-inner">
            <div className="connections-widget">
              <SearchWidget {...this.props} filters={this.state.filters} position="leftNav"/>
            </div>
          </div>
        </div>
      );
    }
}

leftNav.propTypes = {
  className: PropTypes.string,
};

export default leftNav;



// WEBPACK FOOTER //
// ./src/app/components/partner-finder/leftNav-partnerFinder.jsx